import find from 'lodash/find'
import { getClientId } from '@/utils/client'

export default {
  props: {
    id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      client: null
    }
  },
  mounted () {
    this.findClient()
  },
  watch: {
    id () {
      this.findClient()
    }
  },
  methods: {
    findClient () {
      const id = getClientId(this.$store.state.clients.ordered, this.id)
      let client = null
      if (id === 'global-overview') {
        client = { id }
      } else {
        client = find(this.$store.state.clients.ordered, { id })
      }
      this.$set(this, 'client', client)
    }
  }
}
